module.exports = __webpack_public_path__ + "img/qr.d7285d5c.jpg";